<template>
  <div class="paging">
    <ul class="pagination">
      <li v-if="options.current !== 1">
        <a class="interactive-cursor" @click="goToPage(options.current - 1)">
          {{ options.prevText }}
        </a>
      </li>
      <template v-for="i in pages" track-by="$index">
        <li v-if="i == '...'">
          <a>{{ i }}</a>
        </li>
        <li v-else :class="{ 'active' : i == options.current }">
          <a class="interactive-cursor" @click="goToPage(i)">
            {{ i }}
          </a>
        </li>
      </template>
      <li v-if="options.current !== options.totalPages">
        <a class="interactive-cursor" @click="goToPage(options.current + 1)">
          {{ options.nextText }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PagingInput',
  props: {
    options: { type: Object }
  },
  data () {
    return {
      pages: []
    }
  },
  events: {
    'pagesUpdated': function (opts) {
      this.pages = this.paginate(opts)
    }
  },
  methods: {
    goToPage (page) {
      this.$dispatch('changePage', page)
    },
    paginate (opts) {
      const defOpts = {
        current: 1,
        totalResults: 10,
        totalPages: 1,
        padding: 1,
        paddingText: '...',
        nextText: '>',
        prevText: '<',
        limit: 10
      }
      let options = Object.assign(defOpts, opts)
      let pageArray = []
      options.totalPages = Math.ceil(options.totalResults / options.limit)
      this.options = options
      if (options.totalPages < 7) {
        for (let i = 1; i <= options.totalPages; i++) {
          pageArray.push(i)
        }
      } else {
        let range = []
        for (let i = 1; i <= options.totalPages; i++) {
          if (i === 1 || i === options.totalPages || i >= options.current - 1 && i <= options.current + 1) {
            range.push(i)
          }
        }
        let j
        range.forEach(i => {
          if (j) {
            if (i - j === 2) {
              pageArray.push(j + 1)
            } else if (i - j !== 1) {
              pageArray.push('...')
            }
          }
          pageArray.push(i)
          j = i
        })
      }
      return pageArray
    }
  }
}
</script>



// WEBPACK FOOTER //
// PagingInput.vue?c8fd2a12